<template>
    <div class="mb-64 rounded p-32 max-w-1440 mx-auto flex">
        <div class="w-2/3 pr-8">
            <campaign-details :campaign="campaign" class="mb-24"/>
        </div>
        <div class="w-1/3 pl-8">
            <div
                class="bg-white shadow p-24 rounded border trans-ease border-white transition-all duration-150 sticky top-16">
                <h2 class="font-semibold text-body mb-4 first-letter:uppercase">
                    {{ $t('general.summary') }}
                </h2>
                <div class="flex justify-between items-center mb-32">
                    <p class="first-letter:uppercase font-semibold text-black">
                        {{ $t('campaigns.total_cost') }}
                    </p>
                    <p class="font-semibold text-body-sm inline-flex items-center">
                        <currency/>
                        <span>{{ formatPrice(campaign.channels_total_price) }}</span>
                    </p>
                </div>
                <h3 class="mb-8 first-letter:uppercase font-semibold text-black">
                    {{ $t('campaigns.channels') }}
                </h3>
                <div v-for="channel in campaign.channels" :key="channel.id" class="mb-8 bg-primary-5 border border-primary-20 p-8 rounded shadow-sm">
                    <div class="flex justify-between items-end">
                        <p>{{
                            channel.name[locale] ?
                            channel.name[locale] :
                            channel.name[fallbackLocale]
                        }}</p>
                        <p class="font-semibold shrink-0 inline-flex items-center">
                            <currency/>
                            <span>{{ formatPrice(channel.price) }}</span>
                        </p>
                    </div>
                </div>
                <template v-if="currentCompany.free_trial">
                    <banner
                        :title="$t('campaigns.editor.review.trial.title')"
                        :description="$t('campaigns.editor.review.trial.description')"
                        inline
                        :one-line="false"
                    />
                </template>
                <template v-else>
                    <simple-button
                        class="w-full mt-16"
                        :disabled="saving"
                        display="secondary"
                        look="primary"
                        @click="confirmStart = true"
                    >
                        {{ $t('campaigns.editor.payment.button') }}
                    </simple-button>
                    <p class="font-semibold text-primary-80 mt-16">{{ $t('campaigns.editor.payment.warning') }}</p>
                </template>
            </div>
        </div>
        <popup-modal-confirm v-if="confirmStart" @close="confirmStart = false"
                             @confirm="save()" confirm-button="success"
                             :title="$t('campaigns.editor.review.confirm_title')"
                             :message="$t('campaigns.editor.review.confirm_message')"
                             :confirm-text="$t('campaigns.editor.payment.button')" :working="saving"
                             :toggle-text="$t('general.payment_confirmation')">
            <invoice-confirmation-details :title="`Campaign #${campaign.id}`" :price="formatPrice(campaign.channels_total_price)"/>
        </popup-modal-confirm>
    </div>
</template>

<script>
    import Campaign from "../../../models/Campaign";
    import SvgIcon from '../SvgIcon';
    import * as campaigns from '../../../services/CampaignService';
    import Loading from "../Loading";
    import SimpleButton from "../SimpleButton";
    import Form from "../../../etc/forms/Form";
    import {mapState, mapActions} from "pinia";
    import {useMainStore} from '../../../state/store';
    import {useAuthenticationStore} from '../../../state/modules/authentication';
    import {normalizeJson} from "../../../../shared/helpers";
    import CampaignCharacteristics from "../../CampaignCharacteristics";
    import CampaignDetails from "../../CampaignDetails";
    import PopupModalConfirm from "../PopupModalConfirm";
    import BillingDetails from "../../../models/BillingDetails";
    import InvoiceConfirmationDetails from "../../InvoiceConfirmationDetails";
    import Currency from '../../Currency';
    import Banner from "../Banner.vue";

    export default {
        components: {
            Banner,
            InvoiceConfirmationDetails,
            PopupModalConfirm, CampaignDetails, CampaignCharacteristics, SimpleButton, Loading, SvgIcon, Currency},
        props: {
            saving: Boolean,
            campaign: Campaign,
            tab: Number
        },
        data() {
            return {
                form: new Form([
                    { name: 'step', value: 'end' },
                    { name: 'status', value: 'open' }
                ]),
                confirmStart: false
            }
        },
        computed: {
            ...mapState(useMainStore, ['locale']),
            ...mapState(useAuthenticationStore, ['currentCompany']),
            fallbackLocale () {
                return Jobtoolz.config.translatable.fallback_locale;
            }
        },
        methods: {
            /*fetchChannels() {
                this.fetchingChannels = true;

                const ids = this.campaign.channels.map(s => s.channel_id);
                return channels.index(ids)
                    .then(result => {
                        return Channel.insertOrUpdate({ data: normalizeJson(result.data) })
                    })
                    .then(() => {
                        this.fetchingChannels = false;
                    })
            },*/

            save(todo) {
                this.$emit('save', {
                    form: this.form,
                    todo
                });
            },

            formatPrice(price) {
                return price.toFixed(2).replace('.', ',');
            }
        }
    }
</script>
